import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['Bzp'],
});

export const bzpApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    // findAllBzps: builder.query({
    //   query: () => `location_masters/`,
    //   providesTags: ['Bzp'],
    // }),
    findAllBzps: builder.query({
      query: (payload) => {
        let url = `location_masters/`;
        let params = {};
        if (payload) {
          Object.keys(payload).forEach((key) => {
            if (payload[key] !== null) {
              params[key] = payload[key];
            }
          });
        }
        return { url, params: params };
      },
      providesTags: ['Company'],
    }),
    findBzpById: builder.query({
      query: (id) => `location_masters/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'Bzp', id: result.id }] : ['Bzp'];
      },
    }),
    createBzp: builder.mutation({
      query: (bzp) => ({
        url: `location_masters/`,
        method: 'POST',
        body: bzp,
      }),
      invalidatesTags: ['Bzp'],
    }),
    updateBzp: builder.mutation({
      query: (bzp) => ({
        url: `location_masters/${bzp.id}/`,
        method: 'PATCH',
        body: bzp,
      }),
      invalidatesTags: ['Bzp'],
    }),
    deleteBzp: builder.mutation({
      query: (bzp) => ({
        url: `location_masters/${bzp.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Bzp'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllBzpsQuery,
  useFindBzpByIdQuery,
  useCreateBzpMutation,
  useUpdateBzpMutation,
  useDeleteBzpMutation,
} = bzpApi;
